module.exports = __webpack_public_path__ + "img/orange_012.9550536d.png";